import React from 'react'
import { Link } from 'gatsby'
import Container from './container'
import logo from '../images/svgs/moog-logo.svg'
import { useTheme } from '@emotion/react'
import Socials from './socials'
import NewsletterSignup from './newsletter-signup'
import { DownloadLinks, SupportLinks } from './nav-support'

export default function Footer() {
    const theme = useTheme()
    return <footer>
        <Container>
            <div css={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 20,
                padding: '24px 0',
                margin: '32px 16px',
                borderTop: `1px solid ${theme.colors.mutedDark}`,
                '@media(max-width: 768px)': {
                    gridTemplateColumns: 'repeat(2, 1fr)',
                },
                '@media(max-width: 425px)': {
                    gridTemplateColumns: 'repeat(1, 1fr)',
                }
            }}>
                <div>
                    <Link to='/'>
                        <img src={logo} alt="Moog Music" css={{ marginBottom: 40 }} />
                    </Link>
                    <Socials />
                </div>
                <div>
                    <div css={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <h6 css={{ fontSize: 13, }}>Support</h6>
                        <SupportLinks />
                    </div>

                    <div css={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 24 }}>
                        <h6 css={{ fontSize: 13, }}>Downloads</h6>
                        <DownloadLinks />
                    </div>
                </div>
                <div>
                    <div css={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <h6 css={{ fontSize: 13, }}>The Wave</h6>
                        <Link to='/the-wave'>
                            View all articles
                        </Link>
                    </div>
                    
                    <div css={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 24 }}>
                        <h6 css={{ fontSize: 13, }}>About Us</h6>
                        <a href='https://inmusicbrands.pinpointhq.com/' target='_blank' rel='noreferrer'>
                            Careers
                        </a>
                        <Link to='/terms-of-use'>Terms Of Use</Link>
                        <Link to='/privacy'>Privacy</Link>
                    </div>

                    <div css={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 24 }}>
                        <Link to='/dealers' css={{ fontWeight: 700, }}>Find A Dealer</Link>
                    </div>
                </div>
                <NewsletterSignup />
            </div>
        </Container>
    </footer>
}